import { BaseModel } from './BaseInterface';
export const TimeHorizonsBase: BaseModel[] = [
  {
    key: '5years',
    userInput: '5 years or less',
    apiValue: 1,
    dbValue: '5',
    score: 20
  },
  {
    key: '6-10years',
    userInput: '6-10 years',
    apiValue: 6,
    dbValue: '10',
    score: 40
  },
  {
    key: '11-15years',
    userInput: '11-15 years',
    apiValue: 11,
    dbValue: '15',
    score: 60
  },
  {
    key: '16-20years',
    userInput: '16-20 years',
    apiValue: 16,
    dbValue: '20',
    score: 80
  },
  {
    key: '21years',
    userInput: '21 years or more',
    apiValue: 21,
    dbValue: '20+',
    score: 100
  }
];
